module.exports = __webpack_public_path__ + "img/47_01.ce3e6d46.png";